
import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';


//Simple Month class to get month from user
//Displaying it in words and storing result in number

export type MonthsClass = Array<{inWords: string, inNumber: string}>;

@Component({
  selector: 'calendar-type-dialog',
  templateUrl: './calendar-type-dialog.component.html',
  styleUrls: ['calendar-type-dialog.component.css']
})

export class CalendarTypeDialogComponent implements OnInit{


  //Generating month array for all the possible months
  months : MonthsClass = [{inWords:"Jan", inNumber :"1"},{inWords :"Feb", inNumber : "2"},{inWords :"Mar", inNumber :"3"},{inWords :"Apr", inNumber:"4"},{inWords:"May", inNumber:"5"},
    {inWords:"Jun", inNumber:"6"},{inWords:"July", inNumber:"7"},{inWords:"Aug", inNumber:"8"},{inWords:"Sep", inNumber:"9"},{inWords:"Oct", inNumber:"10"},{inWords:"Nov", inNumber:"11"},
    {inWords:"Dec", inNumber:"12"}];

  //array to store years
  years : string[] = [];

  selectedMonth : string = "Month";
  selectedYear : string;
  selectedMonthIndex : number;

  constructor(public dialogRef: MatDialogRef<CalendarTypeDialogComponent>) {}

  //user clicked on a month
  clickedMonth(index : number){

    this.selectedMonth = this.months[index].inWords;
    this.selectedMonthIndex = index;
  }

  clickedYear(index : number){
    this.selectedYear = this.years[index].toLocaleString();
  }


  //Initalize years and month array
  ngOnInit():void{
    let currentYear : number = (new Date()).getFullYear();
    this.selectedYear = currentYear.toString();
    this.selectedMonth = this.months[(new Date()).getMonth()].inWords;
    this.selectedMonthIndex = (new Date()).getMonth();
    while(currentYear >= 1900){
      this.years.push(currentYear.toString());
      currentYear = currentYear - 1;
    }
  }


  //return the saved month and year
  saved() : string{
    return (this.selectedMonthIndex+1) + "-" + this.selectedYear;
  }

}



// WEBPACK FOOTER //
// ./src/app/questions-type/calendar-type/calendar-type-dialog/calendar-type-dialog.component.ts